// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"47":"e97c1038","249":"a74250c5","396":"e0240847","553":"9013ce52","655":"493e975e","855":"12d98ac9"}[chunkId] + ".chunk.css";
};